export default class SelectComponent {
	constructor() {
		this.selector = 'div#kt_app_header_menu';
		this.bodySelector = 'kt_app_body';
		this.itemSelector = 'div.menu-item';
		this.headerContainerSelector = 'div#kt_app_header_container';
		this.additionalElementsInTopMenu = [
			'div#projectNameContainer',
			'div#snippet--headerNavbar',
		];
		this.mobileMenuBreakpoint = 990;
		this.basicWidth = 30;

		document.addEventListener("afterInitMetronicComponents", () => this.init(), {once: true});
	}

	init() {
		const topMenu = document.querySelector(this.selector);
		const headerContainer = document.querySelector(this.headerContainerSelector);

		if (!topMenu || !headerContainer || topMenu.getAttribute('data-responsive-init') === '1') {
			return;
		}

		topMenu.setAttribute('data-responsive-init', "1");
		topMenu.setAttribute('data-original-width', topMenu.offsetWidth);

		this.addOnResizeEvent();
		this.addEventListenersInMenuItems(topMenu);

		if (this.isResponsiveMenuRequired(topMenu, headerContainer)) {
			topMenu.classList.add('menu-responsive');
		} else {
			topMenu.classList.remove('menu-responsive')
		}
	}

	addEventListenersInMenuItems(topMenu) {
		Array.prototype.forEach.call(document.querySelectorAll(this.selector + ' > ' + this.itemSelector), (item) => {
			item.addEventListener('mouseover', (e) => this.itemAnimateOpen(topMenu, item));
			item.addEventListener('mouseleave', (e) => this.itemAnimateClose(topMenu, item));
		});
	}

	itemAnimateOpen(topMenu, item) {
		if (!topMenu.classList.contains('menu-responsive') || item.classList.contains('here') || window.innerWidth <= this.mobileMenuBreakpoint) {
			return;
		}

		item.animate([
			{
				width: `${item.children[0].offsetWidth}px`
			}
		], {
			duration: 300,
			fill: 'forwards',
		});
	}

	itemAnimateClose(topMenu, item) {
		if (!topMenu.classList.contains('menu-responsive') || item.classList.contains('here') || window.innerWidth <= this.mobileMenuBreakpoint) {
			return;
		}

		item.animate([
			{
				width: `${this.basicWidth}px`
			}
		], {
			duration: 600,
			fill: 'forwards',
		});
	}

	addOnResizeEvent() {
		let resizeTimeout;
		const body = document.getElementById(this.bodySelector);

		if (body.getAttribute('data-resize-menu-event-init') === '1') {
			return;
		}

		body.setAttribute('data-resize-menu-event-init', "1");

		window.addEventListener("resize", () => {
			clearTimeout(resizeTimeout);
			resizeTimeout = setTimeout(() => this.checkAfterResize(), 500);
		});
	}

	checkAfterResize() {
		const topMenu = document.querySelector(this.selector);
		const headerContainer = document.querySelector(this.headerContainerSelector);
		console.log('-- Resize updated --');

		if (!topMenu || !headerContainer || !topMenu.hasAttribute('data-responsive-init')) {
			return;
		}

		if (this.isResponsiveMenuRequired(topMenu, headerContainer)) {
			topMenu.classList.add('menu-responsive');
			Array.prototype.forEach.call(document.querySelectorAll(this.selector + ' > ' + this.itemSelector), (item) => this.itemAnimateClose(topMenu, item));
		} else {
			Array.prototype.forEach.call(document.querySelectorAll(this.selector + ' > ' + this.itemSelector), (item) => this.itemAnimateOpen(topMenu, item));
			topMenu.classList.remove('menu-responsive');
		}
	}

	isResponsiveMenuRequired(topMenu, headerContainer) {
		const menuWidth = parseFloat(topMenu.getAttribute('data-original-width'));
		const containerLeftPadding = parseFloat(getComputedStyle(headerContainer).paddingLeft);
		const containerRightPadding = parseFloat(getComputedStyle(headerContainer).paddingRight);
		const windowWidth = document.documentElement.clientWidth;
		let totalAdditionalElementsWidth = containerLeftPadding + containerRightPadding;

		this.additionalElementsInTopMenu.forEach((additionalElement) => {
			const rect = document.querySelector(additionalElement).getBoundingClientRect();
			totalAdditionalElementsWidth += rect.width;
		});

		return menuWidth + totalAdditionalElementsWidth > windowWidth;
	}

}
